import { DS_BREAKPOINT, DS_SHAPE_SPACING } from '@calm/evexia-design-tokens';

export const BANNER_V2_HEIGHT = 450;

export const BANNER_V2_MAX_WIDTH =
    DS_BREAKPOINT.ULTRA - 2 * DS_SHAPE_SPACING.SIDE_LARGE; // 1376;
